import React, { useEffect } from "react";
import { useState } from "react";
import notification from "antd/lib/notification";
import { loginUser, registerUser } from "../services/NewAuthService";
import { Link, useNavigate } from "react-router-dom";
import Step3 from "../components/signup-steps/Step3";
import Step1 from "../components/signup-steps/Step1";
import Indicator from "../components/signup-steps/Indicator";
import { getImageBaseUrl } from "../services/s3-utils";
import { useDispatch, useSelector } from "react-redux";
import { updateUserSlice } from "../store/slices/userSlice";
import { GetUser } from "../services/NewAuthService";
import MetisAxios from "../services/Axios";
import SEO from "../components/Seo";

function Signup(props) {
  const [currStep, setCurrStep] = useState(1);
  const [payload, updatePayload] = useState({});
  const [fields, setFields] = useState({});
  const [loading, setLoading] = useState(false);
  const [user_type, set_user_type] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stepsCount = [1, 2];
  let params = new URLSearchParams(window.location.search);
  const returnUrl = params.get("returnUrl");
  const qalortUser = useSelector((state) => state.user.userData);
  const steps = {
    1: {
      title: "Start Learning 😃",
      subtitle:
        "Learn progressively and build your knowledge bank with the qalort platform.",
    },
    2: {
      title: "Tell Us More About You 😃",
      subtitle:
        "Help us tailor your account to fit your taste. Tick one of the options below",
    },
    3: {
      title: "Yay The Final Step! 😃",
      subtitle: `Let's shape your qalort experience. Select your interests to get started.`,
    },
    4: {
      title: "Start Learning 😃",
      subtitle:
        "Learn progressively and build your knowledge bank with the qalort platform.",
    },
    5: {
      title: "Tell Us More About You 😃",
      subtitle:
        "Help us tailor your account to fit your taste. Tick one of the options below",
    },
    6: {
      title: "Yay The Final Step! 😃",
      subtitle: `Let's shape your qalort experience. Select your interests to get started.`,
    },
  };

  const loginHandler = async (values) => {
    const { email, password } = values;
    // No need to manually lowercase email as normalizeEmail will handle it
    const data = { email, password };

    try {
      const response = await loginUser(data);
      const token = response.data.meta.token;
      localStorage.setItem("qalort_token", token);
      MetisAxios.defaults.headers.common.Authorization = `Bearer ${token}`;

      getMe(token, response.data.data);
    } catch (error) {
      notification.error({
        description: error.message || "An error occurred. Please try again",
      });
    } finally {
      setLoading(false);
    }
  };

  const getMe = (token, userInfo) => {
    const req = GetUser(token);
    req
      .then((res) => {
        let data = res.data;
        const payload = {
          ...userInfo,
          ...data.data,
          user_type,
          full_name: `${data?.data?.first_name} ${data?.data?.last_name}`,
          token,
        };
        dispatch(updateUserSlice(payload));
        navigate(
          returnUrl
            ? returnUrl
            : user_type !== "instructor"
            ? "/mentors"
            : "/profile/complete"
        );
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setCurrStep(0);
      });
  };

  const onSubmit = async (payload) => {
    if (!user_type) {
      notification.error({ description: "Please select a user type" });
      return;
    }
    setLoading(true);
    let data = {
      ...payload,
      provider: "",
      social_id: "",
      user_type,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    const { email, password } = data;

    try {
      await registerUser(data);
      loginHandler({ email, password });
    } catch (error) {
      notification.error({
        description: error.message || "An error occurred. Please try again",
      });
      setLoading(false);
    }
  };

  const setPayload = (data) => {
    updatePayload({
      ...payload,
      ...data,
    });
  };

  useEffect(() => {
    qalortUser && navigate("/");
  }, []);

  return (
    <>
      <SEO />
      <div className="flex [@media(min-width:987px)]:p-4 h-screen overflow-hidden">
        <div className="w-[41%] h-full bg-pri-tint flex items-center justify-center relative [@media(max-width:986px)]:hidden">
          <Link to="/">
            <img
              src={`${getImageBaseUrl}/assets/logo.svg`}
              className="absolute md:top-8 md:left-8 top-2 left-2"
              alt=""
            />
          </Link>
          <img
            src={`${getImageBaseUrl}/assets/auth.png`}
            className="w-2/3 hidden md:block"
            alt=""
          />
        </div>
        <div className="flex-1 px-5 [@media(max-width:986px)]:pt-4 [@media(min-width:1200px)]:px-20 pt-[92px] [@media(min-width:1330px)]:pl-[146px] [@media(min-width:1330px)]:pr-[135px] h-full overflow-auto mb-20">
          <Link
            to="/"
            className="hidden [@media(max-width:986px)]:flex border-b border-neutral py-4 mb-[34px] pl-5 pr-5 -ml-5 -mr-5"
          >
            <img
              src={`${getImageBaseUrl}/assets/logo.svg`}
              className="h-8 w-[103px]"
              alt=""
            />
          </Link>
          <div className="text-tint absolute top-0 right-0 flex items-center pt-10 [@media(max-width:986px)]:hidden">
            <span>Do you have an account?</span>
            <Link to="/login">
              <button className="mx-0 md:mx-4 ml-2 bg-pri-tint-3 border-2 bg-white text-tint text-xs py-2 px-4 flex items-center rounded-md border-pri">
                Sign In
              </button>
            </Link>
          </div>

          {currStep === 0 ? (
            <div className="text-center">
              <h1 id="success_header" className="text-2xl font-semibold mt-40">
                Verify Your Email Address 😃
              </h1>
              <h3
                id="success_subheader"
                className="mb-10 text-sm text-tint font-light mx-20"
              >
                An email has been sent to you, Verify your email address to
                continue.
              </h3>

              <button
                id="complete_button"
                onClick={() => navigate("/login")}
                className="bg-pri px-5 py-3 rounded-lg text-white w-full mt-4"
              >
                Next
              </button>
            </div>
          ) : (
            <>
              <h1
                data-testid="page_header"
                className="text-2xl font-semibold text-dark"
              >
                {steps[currStep].title}
              </h1>
              <h3
                data-testid="page_subheader"
                className="[@media(max-width:600px)]:mb-6 mb-8 text-sm text-tint font-light"
              >
                {steps[currStep].subtitle}
              </h3>
              <Step1
                fields={fields}
                currStep={currStep}
                setCurrStep={onSubmit}
                set_user_type={set_user_type}
                user_type={user_type}
                loading={loading}
              />
            </>
          )}
          <p className="text-light text-base leading-[29px] mt-6">
            {" "}
            <span>Do you have an account?</span>{" "}
            <Link to="/login">
              <button className="pri ">Sign In</button>
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}

export default Signup;
